import script from "./PlatformPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformPage.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformPage.vue?vue&type=style&index=0&id=fc9ef68e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc9ef68e"]])

export default __exports__